import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Notifications from 'vue-notification'
import VuejsDialog from 'vuejs-dialog';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Datetime from 'vue-datetime';
import './registerServiceWorker';

Vue.config.productionTip = false;

Vue.use(Notifications);
Vue.use(VuejsDialog);
Vue.use(Datetime);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.devtools = process.env.NODE_ENV !== 'prod';

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#root');
